import $      from 'jquery';
import slick  from 'slick-carousel';

const updateArrowState = ($sliderNav, slick) => {
  const $prev = $sliderNav.find('.slick-prev');
  const $next = $sliderNav.find('.slick-next');

  const isFirst = slick.currentSlide === 0;
  const isLast =
    slick.currentSlide >= slick.slideCount - slick.options.slidesToShow;

  $prev.prop('disabled', isFirst);
  $next.prop('disabled', isLast);
};

const clearActiveSlideTabIndexes = ($slider) => {
  $slider.find('.slick-active a').removeAttr('tabindex');
};

const promotionsCarousel = () => {
  const $slider = $('.js-promotionsCarousel');
  const $sliderNav = $('.js-promotionsCarouselNav');

  $sliderNav.on('init', function (event, slick) {
    updateArrowState($(this), slick);
    clearActiveSlideTabIndexes($slider);
  });

  $sliderNav.on('afterChange', function (event, slick) {
    updateArrowState($(this), slick);
    clearActiveSlideTabIndexes($slider);
  });

  // $slider.on('init afterChange', function () {
  //   clearActiveSlideTabIndexes($slider);
  // });

  $slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    adaptiveHeight: true,
    focusOnSelect: true,
    asNavFor: $sliderNav,
    infinite: false,
    rows: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          dots: true,
          arrows:false
        }
      }
    ]
  });
  $sliderNav.slick({
    arrows:true,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    rows: 0,
    focusOnSelect: true,
    asNavFor: $slider,
    infinite: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 0,
        arrows:false,
        settings: "unslick"
      }
    ]
  });
};

export default promotionsCarousel;
